import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';

if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
}

Vue.config.productionTip = false;
axios.interceptors.response.use( (response) => {
  return response;
}, (error) => {
  const status = error.response?.status;
  const config = error.config || {};
  const skipAuth = config.skipAuthInterceptor;
  if (status === 401 && !skipAuth) {
    store.dispatch("Auth/logout");
  }
  return Promise.reject(error);
});

import Buefy from 'buefy';
import 'mdi/css/materialdesignicons.css';
Vue.use(Buefy, { defaultIconPack: 'mdi' });

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import VueLodash from 'vue-lodash';
import lodash from 'lodash';
Vue.use(VueLodash, { lodash: lodash });

Vue.use(require('vue-moment'));

const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
